// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  install(Vue, options) {

    Vue.prototype.getPdf = function (top,left) {
		console.log(top)
      var title = this.text_name;
	  var paperType = this.paper_type;//纸张类型

		 //只下载id为pdfDom的内容
		 html2Canvas(document.querySelector('#pdfDom'), { //body是下载整个界面
		   useCORS: true, //是否尝试使用CORS从服务器加载图像
		   allowTaint: false,
		   dpi:300, //解决生产图片模糊
		   backgroundColor:'#FFFFFF',
		   // width: 2463, //canvas宽度
		   // height:1748, //canvas高度
		   x:0, //x坐标
		   // y:-1120, //y坐标
		   y:-(top), //y坐标
		   // y:302.3, //y坐标
		   async:true, //是否异步解析和呈现元素
		 	taintTest: true, //在渲染前测试图片
		   foreignObjectRendering: true, //是否在浏览器支持的情况下使用ForeignObject渲染
		 	proxy:'http://localhost:8080'
		 }).then(function (canvas) {
		 		   document.querySelector(".tp-posters-picture").appendChild(canvas);
				   // return false
				   //  l：横向  p：纵向
				   // 测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
				   // a0 - a10
					// b0 - b10
					// c0 - c10
					// dl
					// letter
					// government-letter
					// legal
					// junior-legal
					// ledger
					// tabloid
		 		  // var pdf = new JsPDF('p', 'mm', 'a4'); 
				  let pdf  ='';
				  let a4w =0,a4h=0; //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
				  if(paperType==2){
					  pdf = new JsPDF('p', 'mm', 'a4');
					  a4w = 210;
					  a4h = 297;
				  }else if(paperType==1){
					  pdf = new JsPDF('l', 'mm', 'a3');
					  a4w = 420;
					  a4h = 297;
				  }else{
					  pdf = new JsPDF('l', 'mm', 'b4');
					  a4w = 364;
					  a4h = 257;
				  }
				
				
		 		   var ctx = canvas.getContext('2d'),
					   // 297mm×420mm A3
		 		       imgHeight = Math.ceil(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
		 		       renderedHeight = 0;
					    
		 			   while(renderedHeight < canvas.height) {
		 			       var page = document.createElement("canvas");
		 			       page.width = canvas.width;
		 			       page.height = Math.floor(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
		 			   
		 			       //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
		 			       page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.floor(imgHeight, canvas.height - renderedHeight)), 0, 0);
		 				  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0.5, a4w, Math.floor(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
		 			     
		 			       renderedHeight += imgHeight;
		 			       if(renderedHeight < canvas.height)
		 			           pdf.addPage();//如果后面还有内容，添加一个空页
		 			   }
		 			    pdf.save(`${title}.pdf`);
		 })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/htmlToPdf.js